import { InsertTable } from './insert-table.js';
import { EditTable } from './edit-table.js';


export function Table (pEditor)
{
  this.insert = new InsertTable(pEditor, this);
  this.edit = new EditTable(pEditor, this);
  
  
  this.queryInsertTableState = (pButton, command) =>
  {
    return false;
  };


  this.openTableDropdown = (pButton) =>
  {
    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
    {
      return false;
    }

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      pEditor.pDropdown.setReturnedParameters('selectedStyleId', '');
      pEditor.pDropdown.setReturnedParameters('openInsertTableDialog_disabled', !this.insert.queryOpenInsertTableDialogEnabled(pButton));
      pEditor.pDropdown.setReturnedParameters('setTableCellsPadding_disabled', !this.edit.queryBasicEditTable());
      pEditor.pDropdown.setReturnedParameters('deleteTable_disabled', !this.edit.queryBasicEditTable());
      pEditor.pDropdown.setReturnedParameters('showHideTablesBorders_current', !this.edit.queryStateTablesBorders());
      pEditor.pDropdown.setReturnedParameters('menuDisabled', !this.edit.queryBasicEditTable());
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'tableDropdownHandler');
    }
  };


  function tableDropdownHandler (pButton, command)
  {
    var pParameters,
        sCommand,
        tCommand,
        sTitle;

    pEditor.pDropdown = pButton.getDropdown();

    if (pEditor.pDropdown)
    {
      pParameters = pEditor.pDropdown.getReturnedParameters();
    }

    if (pParameters && pParameters.itemMenuCommand)
    {
      sCommand = pParameters.itemMenuCommand;
    }

    if (pParameters && pParameters.itemMenuTitle)
    {
      sTitle = pParameters.itemMenuTitle;
    }

    if (pParameters && pParameters.selectedStyleId)
    {
      tCommand = pParameters.selectedStyleId;
    }

    pEditor.closeDropdown(pButton);

    if (tCommand && tCommand.indexOf('Color') != -1)
    {
      sCommand = tCommand;
      tCommand = 'More';
    }

    if (sCommand && (sCommand.indexOf('BackgroundColor') != -1 || sCommand.indexOf('BorderColor') != -1 || sCommand.indexOf('BorderWidth') != -1))
    {
      if (tCommand == 'More')
      {
        pEditor.pThis.execCommand(pButton, 'openTableMoreDialog', {command: sCommand, title: sTitle});
      }
      else
      {
        pEditor.pThis.execCommand(pButton, 'setTableBorderAndBackground', {command : sCommand, value : tCommand});
      }
    }
    else if (sCommand && sCommand.indexOf('Align') != -1)
    {
      pEditor.pThis.execCommand(pButton, 'setTableAlignment', {command : sCommand, value : tCommand});
    }
    else if (sCommand && (sCommand.indexOf('Size') != -1 || sCommand.indexOf('Padding') != -1))
    {
      if (tCommand == 'More')
      {
        pEditor.pThis.execCommand(pButton, 'openTableMoreDialog', {command: sCommand, title: sTitle});
      }
      else
      {
        pEditor.pThis.execCommand(pButton, 'setTableSizeAndPadding', {command : sCommand, value : tCommand});
      }
    }
    else
    {
      pEditor.pThis.execCommand(pButton, tCommand);
    }
  }


  this.tableDropdownHandler = tableDropdownHandler;
}